<template>
  <div class="col-md-12">
    <div v-if="currentState" class="card card-container">
      <h4><font-awesome-icon icon="edit" /> Edit State Details</h4>
      <form name="form" @submit.prevent="updateState">
        <div v-if="!successful">
          <div class="form-group">
            <label for="code">Code:</label>
            <input v-model="currentState.code" v-validate="'required|min:2|max:6'" type="text" class="form-control" id="code" name="code"/>
            <div v-if="submitted && errors.has('code')" class="alert-danger">{{errors.first('code')}}</div>
          </div>
          <div class="form-group">
            <label for="name">Name:</label>
            <input v-model="currentState.name" v-validate="'required|min:3|max:75'" type="text" class="form-control" id="name" name="name"/>
            <div v-if="submitted && errors.has('name')" class="alert-danger" >{{errors.first('name')}}</div>
          </div>
          <div class="form-group">
            <label for="countries">Country: </label>
            <select v-model="currentState.countryId" v-validate="'required'" class="form-control" id="countries" name="countries">
              <option v-for="country in countries" v-bind:value="country.id" :key="country.id">{{ country.name }}</option>
            </select>
            <div v-if="submitted && errors.has('countries')" class="alert-danger">{{errors.first('countries')}}</div>
          </div>
          
          <div class="form-group">
            <button class="badge badge-danger mr-2" @click="deleteState"><font-awesome-icon icon="trash-alt" /> Delete</button>
            <button type="submit" class="badge badge-success mr-2"><font-awesome-icon icon="save" /> Update</button>
            <button class="badge badge-primary" @click="statesList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
          </div>
        </div>
      </form>

      <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
        {{message}}
      </div>
      <div v-if="message && successful">
        <button class="btn btn-primary" @click="statesList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
      </div>
    </div>
    <div v-else>
      <br />
      <p>Please click on a State...</p>
    </div>
  </div>
</template>

<script>
import StateService from "../services/state.service";
import CountryService from "../services/country.service";

export default {
  name: 'state',
  data() {
    return {
      currentState: null,
      submitted: false,
      successful: false,
      message: '',
      //currentUserTypeCode: '',
      //currentUserTypeName: '',
      countries: [],
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  methods: {
    getState(id) {
      StateService.get(id)
        .then(response => {
          this.currentState = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    retrieveCountries() {
      CountryService.getAll()
        .then(response => {
          this.countries = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    
    updateState() {
      this.message = '';
      this.submitted = true;
      //this.currentState.countryId = this.currentcountryId;
      this.$validator.validate().then(isValid => {
        if (isValid) {
          StateService.update(this.currentState.id, this.currentState).then(
            response => {
              console.log(response.data);
              this.message = 'The state was updated successfully!';
              this.successful = true;
            },
            error => {
              this.message = (error.response && error.response.data) || error.message || error.toString();
              this.successful = false;
            })
            .catch(e => {
              console.log(e);
            });
        }
      });
    },

    deleteState() {
      StateService.delete(this.currentState.id)
        .then(response => {
          console.log(response.data);
          this.$router.push({ name: "states" });
        })
        .catch(e => {
          console.log(e);
        });
    },

    statesList() {
      this.$router.push('/states');
    }
  },
  mounted() {
    this.message = '';
    this.getState(this.$route.params.id);
    this.retrieveCountries();
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
  font-size: 1.2em;
  text-align: left;
}

.card-container.card {
  max-width: 750px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>